import { Box3, Vector3 } from "three";

export const getBoundingBoxAndCenterByObject3d = object => {
  const bbox = new Box3().setFromObject(object);
  const center = bbox.getCenter(new Vector3());

  return { bbox, center };
};
